import React from 'react';
import { Progress, Tooltip, Typography } from 'antd';

const EquityEnd = '#5995ED';
const FixedEnd = '#FFAD08';


const TargetAllocations = ({ equity, fixed, size=55 }) => {
  // Error handling for sum not equal to 100
  if (equity + fixed !== 100) {
    console.error('The sum of equity and fixed does not equal 100%');
    return null;
  }

  let strokes = {}
  if (equity===100){
    Object.assign(strokes, {
      '0%': EquityEnd,
      '100%': EquityEnd
    })
  }
  else if (fixed===100){
    Object.assign(strokes, {
      '0%': FixedEnd,
      '100%': FixedEnd
    })
  }
  else {
    Object.assign(strokes, {
      '0%': EquityEnd,
      [`${equity}%`]: EquityEnd,
      [`${equity+1}%`]: FixedEnd,
      '100%': FixedEnd

    })
  }

  return (
    <div style={{ width: '100%' }}>
      <Tooltip title={`Equity: ${equity}%, Fixed: ${fixed}%`}>
        <Progress
          type={'circle'}
          percent={100}
          strokeColor={strokes}
          style={{ marginBottom: '4px' }}
          format={(percent) => <Typography.Text style={{fontSize: 11}} className={'font-medium'}>{equity} / {fixed}</Typography.Text>}
          size={size}
          status={'normal'}
          strokeWidth={4}

          gapPosition={equity>fixed?'right':'left'}
        />
      </Tooltip>
    </div>
  );
};

export default TargetAllocations;
